exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n * \n *  React Simpletabs - Just a simple tabs component built with React\n *  @version v0.7.0\n *  @link https://github.com/pedronauck/react-simpletabs\n *  @license MIT\n *  @author Pedro Nauck (https://github.com/pedronauck)\n * \n */\n.tabs-menu {\n  display: table;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.tabs-menu-item {\n  float: left;\n  margin-right: 20px;\n}\n\n.tabs-menu-item a {\n  cursor: pointer;\n  display: block;\n  color: #A9A9A9;\n}\n\n.tabs-menu-item:not(.is-active) a:hover,\n.tabs-menu-item.is-active a {\n  color: #3498DB;\n}\n\n.tab-panel {\n  padding: 10px 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-simpletabs/dist/react-simpletabs.css
// module id = 390
// module chunks = 0